import React from 'react'
import { Link, graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import { StaticImage } from "gatsby-plugin-image"
import Header from '../components/header'
import Footer from '../components/footer'
import Seo from '../components/seo'

const SlideLink = ({ link, children }) => {
    if (!link) return children
    const isExternal = /^https?:\/\//i.test(link)
    if (isExternal) {
        return (
            <a href={link} title={link} rel="noopener noreferrer">
                {children}
            </a>
        )
    }
    return (
        <Link to={link} title={link}>
            {children}
        </Link>
    )
}

const Flickity =
  typeof window !== "undefined"
    ? require("react-flickity-component")
    : () => null

const fade =
  typeof window !== "undefined"
    ? require("flickity-fade")
    : () => null

const flickityOptions = {
    prevNextButtons: true,
    pageDots: false,
    cellSelector: '.slider__primary-slider-cell',
    wrapAround: false,
    setGallerySize: false,
    cellAlign: 'center',
    autoPlay: true,
    // fade: true
}

function Slider(slides) {
    return (
        <Flickity
            className={'slider slider__primary-slider'}
            elementType={'div'}
            options={flickityOptions}
            disableImagesLoaded={false}
            reloadOnUpdate={true}
            static={true}
        >
            {slides.data.map((slide, i) => {
                const slideImage = (
                    <GatsbyImage
                        image={slide.image.childImageSharp.gatsbyImageData}
                        alt={`slide_` + i + ``}
                        style={{ width: "100%", height: "100%", display: "block" }}
                        imgStyle={{ objectFit: "cover" }}
                    />
                )
                return (
                    <div key={`slide_` + i + ``} className="slider__primary-slider-cell">
                        {slide.link ? (
                            <SlideLink link={slide.link}>
                                {slideImage}
                            </SlideLink>
                        ) : slideImage}
                    </div>
                )
            })}
        </Flickity>
    )
}

const HomePage = ({data}) => {
    const entry = data.markdownRemark
    return (
        <div className="page">
            <Seo title={entry.frontmatter.page_title} description={entry.frontmatter.meta_description} image="" pathname="/" />
            <Header />
            <div className="layout grey">
                <div className="slider__container">
                    <div className="slider__block">
                        <Slider data={entry.frontmatter.slides} />
                    </div>
                </div>
            </div>
            <main className="layout home grey">
                <div className="home__container">
                    <div className="home__flex flex__space-between">
                        <aside className="home__img">
                            <StaticImage src="../images/25Years-Forklift.gif" alt="Kiwi as" style={{ display: "block", width: "100%" }} imgStyle={{ objectFit: "contain", width: "100%" }} />
                            <div className="home__cta-stack">
                                <Link to="/booking/">
                                    <StaticImage src="../images/home-book-online.jpg" alt="Book online" style={{ width: '100%', display: "block", margin: 0, padding: 0 }} imgStyle={{ objectFit: "fill", width: "100%", height: "100%" }} objectFit="fill" />
                                </Link>
                                <Link to="/quote/">
                                    <StaticImage src="../images/home-get-a-quote.jpg" alt="Get a quote" style={{ width: '100%', display: "block", margin: 0, padding: 0 }} imgStyle={{ objectFit: "fill", width: "100%", height: "100%" }} objectFit="fill" />
                                </Link>
                            </div>
                        </aside>
                        <article className="home__intro text">
                            <div dangerouslySetInnerHTML={{ __html: entry.html }} />
                        </article>
                    </div>
                </div>
            </main>
            <div className="layout grey">
                <div className="ads__container">
                    <div className="ads__flex ad_gap">
                        <div className="ad">
                            <a href="https://www.accesssolutions.co.nz/find-solutions/" title="Find Solutions" rel="nofollow noopener">
                                <StaticImage src="../images/step-1.jpg" alt="Find solutions" style={{ width: '100%', height: '100%', display: "block" }} imgStyle={{ objectFit: "cover" }} objectFit="cover" />
                            </a>
                        </div>
                        <div className="ad">
                            <Link to="/solutions/fair-wear-tear/">
                                <StaticImage src="../images/fair_wear_tear_home.jpg" alt="Fair Wear and Tear" style={{ width: '100%', height: '100%', display: "block" }} imgStyle={{ objectFit: "cover" }} objectFit="cover" />
                            </Link>
                        </div>
                        <div className="ad">
                            <Link to="/used-forklifts/">
                                <StaticImage src="../images/ex-lease.jpg" alt="Ex Lease" style={{ width: '100%', height: '100%', display: "block" }} imgStyle={{ objectFit: "cover" }} objectFit="cover" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default HomePage;

export const query = graphql`
	query($slug: String!) {
		markdownRemark( fields: { slug: { eq: $slug } }) {
			frontmatter {
				page_title
				meta_description
                slides {
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                width: 800,
                                placeholder: NONE,
                                quality: 100,
                            )
                        }
                    }
                    link
                }
			}
			fields {
                slug
			}
			html
		}
	}
`
